/**
 * HE global
 * Code in here is used globally
 */

(function Global($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		// init tooltips
		$('body').tooltip({
			selector: '[data-bs-toggle^="tooltip"]'
		});

		// handle simple confirmation links
		$(document).on('click', '.confirm-link', function confirmLink(event) {
			event.preventDefault();
			HE.CustomConfirm.link($(this));
			return false;
		});
	});
}(jQuery, window.HE || {}));